'use es6';

import I18n from 'I18n';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
class SimpleReportsListHeader extends Component {
  constructor(...args) {
    super(...args);
    this.render = () => {
      const {
        alert,
        children
      } = this.props;
      return /*#__PURE__*/_jsx(Header, {
        flush: true,
        marginBlockEnd: "0",
        paddingInline: "500",
        title: I18n.text('reports.header.title'),
        alert: alert,
        children: children
      });
    };
  }
}
SimpleReportsListHeader.propTypes = {
  alert: PropTypes.node,
  children: PropTypes.node
};
export default SimpleReportsListHeader;